import React from 'react';
//Components
import Menu from '../components/menu/menu';
import Footer from '../components/footer/footer';
//
export default function Index(props){
    return(
        <>
            {/* TopBar Menu */}
            <Menu menuList={props.menuList} 
                    pageTitle={props.pageTitle} 
                    branding={props.branding}
            />
            {/* Conteúdo da Página */}
            {props.children}
            {/* Footer da Página */}
            <Footer menuList={props.menuList} 
                    pageTitle={props.pageTitle}
                    facebook='https://www.facebook.com/Psievoluir.01?_rdc=2&_rdr'
                    instagram='https://www.instagram.com/psievoluir.01/'
                    branding={props.branding} 
                    brandingText='Plantando a semente para, em breve, colher os frutos.'
                    contactList={[
                        "Salvador, BA",
                        "+55 71 9 9320-7963",
                        "+55 71 9 9191-7221",
                        "psievoluir.01@gmail.com",
                    ]}
            />
        </>
    )
};